import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Singapore() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useLayoutEffect(() => {
        const savedForm = JSON.parse(localStorage.getItem('form'));
        const savedType = savedForm?.country?.type;

        if (savedType) {
            setType(savedType);
        }
    }, []);

    useLayoutEffect(() => {
        const fetchData = () => {
            if (!userEmail) {
                navigate('/');
                return;
            }

            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Singapore') {
                // Delay ensures DOM + conditional inputs exist
                setTimeout(() => {
                    fillForm(form);
                }, 0);
            }
        };

        fetchData();
    }, [userEmail, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [type, setType] = useState();

    useLayoutEffect(() => {
        const form = JSON.parse(localStorage.getItem('form'));
        if (form && type) {
            setTimeout(() => {
                fillForm(form);
            }, 0);
        }
    }, [type]);

    const [name1, setName1] = useState();
    const [brn1, setBrn1] = useState();
    const [officer1, setOfficer1] = useState();
    const [accNum1, setAccNum1] = useState();
    const [name2, setName2] = useState();
    const [brn2, setBrn2] = useState();
    const [officer2, setOfficer2] = useState();
    const [accNum2, setAccNum2] = useState();
    const [portFrom, setPortFrom] = useState();
    const [portTo, setPortTo] = useState();
    const [date, setDate] = useState();
    // const [applicant, setApplicant] = useState();
    const [signatory, setSignatory] = useState();
    const [date2, setDate2] = useState();

    const [name3, setName3] = useState();
    const [brn3, setBrn3] = useState();
    const [officer3, setOfficer3] = useState();
    const [contact, setContact] = useState();
    const [address, setAddress] = useState();
    const [postal, setPostal] = useState();
    const [date3, setDate3] = useState();
    const [portIn, setPortIn] = useState(false);
    const [portBack, setPortBack] = useState(false);
    //const [signature, setSignature] = useState();
    const [date4, setDate4] = useState();
    const [signatory2, setSignatory2] = useState();

    const [date5, setDate5] = useState();
    const [name4, setName4] = useState();
    const [uen, setUen] = useState();
    //const [signature2, setSignature2] = useState();
    const [name5, setName5] = useState();
    const [title, setTitle] = useState();
    const [name6, setName6] = useState();

    // const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);
    const [tableDataRangeInternal, setTableDataRangeInternal] = useState([{ id: Date.now(), sNumber: '', eNumber: '', numType: '' }]);
    const [tableDataRangeLocal, setTableDataRangeLocal] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);
    const [tableDataRangeN2, setTableDataRangeN2] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    const COMMON_EXCEL_HEADERS = [
        'Public from',
        'Public to',
        'Private from',
        'Private to',
        'Local Country Value',
    ];

    const TABLES = {
        // range: {
        //     data: tableDataRange,
        //     setData: setTableDataRange,
        //     defaultRow: { sNumber: '', eNumber: '' },
        //     digitRegex: /^\d{9,11}$/,
        //     required: true,
        // },
        internal: {
            data: tableDataRangeInternal,
            setData: setTableDataRangeInternal,
            defaultRow: { sNumber: '', eNumber: '', numType: '' },
            digitRegex: /^\d+$/,
            required: true,
        },
        local: {
            data: tableDataRangeLocal,
            setData: setTableDataRangeLocal,
            defaultRow: { sNumber: '', eNumber: '' },
            digitRegex: /^\d+$/,
            required: true,
        },
        n2: {
            data: tableDataRangeN2,
            setData: setTableDataRangeN2,
            defaultRow: { sNumber: '', eNumber: '' },
            digitRegex: /^\d+$/,
            required: false,
        },
    };

    //const fileRefRange = useRef(null);
    const fileRefInternal = useRef(null);
    const fileRefLocal = useRef(null);
    const fileRefN2 = useRef(null);

    const [uploadedFiles, setUploadedFiles] = useState({
        // range: '',
        internal: '',
        local: '',
        n2: '',
    });

    //adding a row
    const addRow = (tableKey) => {
        const { data, setData, defaultRow } = TABLES[tableKey];
        setData([...data, { id: Date.now(), ...defaultRow }]);
    };

    //removing a row
    const removeRow = (tableKey, id) => {
        const { data, setData } = TABLES[tableKey];
        setData(data.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChangeTable = (tableKey, id, key, value) => {
        const { data, setData } = TABLES[tableKey];

        const updated = data.map(row =>
            row.id === id ? { ...row, [key]: value } : row
        );

        setData(updated);
    };

    // file upload function
    const handleFileUpload = (event, tableKey) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFiles(prev => ({
            ...prev,
            [tableKey]: file.name,
        }));

        const { setData, digitRegex, required } = TABLES[tableKey];

        const reader = new FileReader();
        reader.onload = (e) => {
            const workbook = XLSX.read(new Uint8Array(e.target.result), { type: 'array' });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];

            const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1, range: 4 });

            if (!jsonData.length) {
                toast.error('Uploaded file is empty or invalid.');
                return;
            }

            if (!COMMON_EXCEL_HEADERS.every((h, i) => h === jsonData[0][i])) {
                toast.error('Uploaded file does not match the expected template.');
                setUploadedFiles(prev => ({ ...prev, [tableKey]: '' }));
                return;
            }

            const rows = jsonData.slice(1).map((row, i) => ({
                id: i + 1,
                sNumber: row[0]?.toString().trim() || '',
                eNumber: row[1]?.toString().trim() || '',
            }));

            //ALWAYS SET DATA (this fixes rendering)
            setData(rows);

            rows.forEach(row => {
                let startValid = true;
                let endValid = true;

                // ---- START ----
                if (required && !row.sNumber) {
                    toast.error(`Row ${row.id}: Start number cannot be empty.`);
                    startValid = false;
                } else if (row.sNumber && !/^\d+$/.test(row.sNumber)) {
                    toast.error(`Row ${row.id}: Start number must be numeric.`);
                    startValid = false;
                } else if (row.sNumber && !digitRegex.test(row.sNumber)) {
                    toast.error(
                        tableKey === 'range'
                            ? `Row ${row.id}: Start number must be 9–11 digits.`
                            : `Row ${row.id}: Start number is invalid.`
                    );
                    startValid = false;
                }

                // ---- END ----
                if (required && !row.eNumber) {
                    toast.error(`Row ${row.id}: End number cannot be empty.`);
                    endValid = false;
                } else if (row.eNumber && !/^\d+$/.test(row.eNumber)) {
                    toast.error(`Row ${row.id}: End number must be numeric.`);
                    endValid = false;
                } else if (row.eNumber && !digitRegex.test(row.eNumber)) {
                    toast.error(
                        tableKey === 'range'
                            ? `Row ${row.id}: End number must be 9–11 digits.`
                            : `Row ${row.id}: End number is invalid.`
                    );
                    endValid = false;
                }

                //MATCH JSX IDs
                setValidationStates(prev => ({
                    ...prev,
                    [`startNumber-${tableKey}-${row.id}`]: startValid,
                    [`endNumber-${tableKey}-${row.id}`]: endValid,
                }));
            });
        };

        reader.readAsArrayBuffer(file);
    };

    // remove uploaded file
    const removeUploadedFile = (tableKey, fileRef) => {
        fileRef.current.value = '';

        setUploadedFiles(prev => ({
            ...prev,
            [tableKey]: '',
        }));

        const { setData, defaultRow } = TABLES[tableKey];
        setData([{ id: Date.now(), ...defaultRow }]);
    };

    // download the template
    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-----------------------------------------------FillForm-------------------------------------------------//

    const setInput = (id, value) => {
        const el = document.getElementById(id);
        if (el) {
            el.value = value ?? '';
        }
    };

    const fillForm = (form) => {
        const internal = form?.country?.internal ?? {};
        const local = form?.country?.local ?? {};
        const mandatory = form?.country?.mandatory ?? {};

        /* ========= INTERNAL ========= */
        setInput('name1', internal.name1);
        setName1(internal.name1 ?? '');

        setInput('brn1', internal.brn1);
        setBrn1(internal.brn1 ?? '');

        setInput('officer1', internal.officer1);
        setOfficer1(internal.officer1 ?? '');

        setInput('accNum1', internal.accNum1);
        setAccNum1(internal.accNum1 ?? '');

        setInput('name2', internal.name2);
        setName2(internal.name2 ?? '');

        setInput('brn2', internal.brn2);
        setBrn2(internal.brn2 ?? '');

        setInput('officer2', internal.officer2);
        setOfficer2(internal.officer2 ?? '');

        setInput('accNum2', internal.accNum2);
        setAccNum2(internal.accNum2 ?? '');

        setInput('portFrom', internal.portFrom);
        setPortFrom(internal.portFrom ?? '');

        setInput('portTo', internal.portTo);
        setPortTo(internal.portTo ?? '');

        setTableDataRangeInternal(internal.internal ?? []);

        setInput('date', internal.date);
        setDate(internal.date ?? '');

        // setInput('applicant', internal.applicant);
        // setApplicant(internal.applicant ?? '');

        setInput('signatory', internal.signatory);
        setSignatory(internal.signatory ?? '');

        setInput('date2', internal.date2);
        setDate2(internal.date2 ?? '');

        /* ========= LOCAL ========= */
        setInput('name3', local.name3);
        setName3(local.name3 ?? '');

        setInput('brn3', local.brn3);
        setBrn3(local.brn3 ?? '');

        setInput('officer3', local.officer3);
        setOfficer3(local.officer3 ?? '');

        setInput('contact', local.contact);
        setContact(local.contact ?? '');

        setInput('address', local.address);
        setAddress(local.address ?? '');

        setInput('postal', local.postal);
        setPostal(local.postal ?? '');

        setTableDataRangeLocal(local.local ?? []);
        setTableDataRangeN2(local.n2 ?? []);

        setInput('date3', local.date3);
        setDate3(local.date3 ?? '');

        setInput('portIn', local.portIn);
        setPortIn(local.portIn ?? '');

        setInput('portBack', local.portBack);
        setPortBack(local.portBack ?? '');

        // setInput('signature', local.signature);
        // setSignature(local.signature ?? '');

        setInput('date4', local.date4);
        setDate4(local.date4 ?? '');

        setInput('signatory2', local.signatory2);
        setSignatory2(local.signatory2 ?? '');

        /* ========= MANDATORY ========= */
        setInput('date5', mandatory.date5);
        setDate5(mandatory.date5 ?? '');

        setInput('name4', mandatory.name4);
        setName4(mandatory.name4 ?? '');

        setInput('uen', mandatory.uen);
        setUen(mandatory.uen ?? '');

        //setTableDataRange(mandatory.range ?? []);

        // setInput('signature2', mandatory.signature2);
        // setSignature2(mandatory.signature2 ?? '');

        setInput('name5', mandatory.name5);
        setName5(mandatory.name5 ?? '');

        setInput('title', mandatory.title);
        setTitle(mandatory.title ?? '');

        setInput('name6', mandatory.name6);
        setName6(mandatory.name6 ?? '');
    };

    //-----------------------------------------------ClearingForm-------------------------------------------------//

    const isInitialLoad = useRef(true);

    useEffect(() => {
        if (isInitialLoad.current) {
            isInitialLoad.current = false;
            return; //do NOT clear on restore
        }

        if (type) {
            clearFormByType(); //clear ONLY when user switches type
        }
    }, [type]);

    const clearInput = (id) => {
        const el = document.getElementById(id);
        if (el) el.value = '';
    };

    const getEmptyMandatoryRow = () => ({
        id: Date.now(),
        sNumber: '',
        eNumber: ''
    });

    const getEmptyInternalRow = () => ({
        id: Date.now(),
        sNumber: '',
        eNumber: '',
        numType: ''
    });

    const getEmptyLocalRow = () => ({
        id: Date.now(),
        sNumber: '',
        eNumber: ''
    });

    const getEmptyN2Row = () => ({
        id: Date.now(),
        sNumber: '',
        eNumber: ''
    });

    const clearFormByType = () => {
        /* ========= INTERNAL ========= */
        clearInput('name1'); setName1('');
        clearInput('brn1'); setBrn1('');
        clearInput('officer1'); setOfficer1('');
        clearInput('accNum1'); setAccNum1('');
        clearInput('name2'); setName2('');
        clearInput('brn2'); setBrn2('');
        clearInput('officer2'); setOfficer2('');
        clearInput('accNum2'); setAccNum2('');
        clearInput('portFrom'); setPortFrom('');
        clearInput('portTo'); setPortTo('');
        setTableDataRangeInternal([getEmptyInternalRow()]);
        clearInput('date'); setDate('');
        //clearInput('applicant'); setApplicant('');
        clearInput('signatory'); setSignatory('');
        clearInput('date2'); setDate2('');

        /* ========= LOCAL ========= */
        clearInput('name3'); setName3('');
        clearInput('brn3'); setBrn3('');
        clearInput('officer3'); setOfficer3('');
        clearInput('contact'); setContact('');
        clearInput('address'); setAddress('');
        clearInput('postal'); setPostal('');
        setTableDataRangeLocal([getEmptyLocalRow()]);
        setTableDataRangeN2([getEmptyN2Row()]);
        clearInput('date3'); setDate3('');
        clearInput('portIn'); setPortIn(false);
        clearInput('portBack'); setPortBack(false);
        //clearInput('signature'); setSignature('');
        clearInput('date4'); setDate4('');
        clearInput('signatory2'); setSignatory2('');

    };

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        country: {
            country: "Singapore",
            type: type,

            internal:
                type === "Internal Porting"
                    ? {
                        name1: name1,
                        brn1: brn1,
                        officer1: officer1,
                        accNum1: accNum1,
                        name2: name2,
                        brn2: brn2,
                        officer2: officer2,
                        accNum2: accNum2,
                        portFrom: portFrom,
                        portTo: portTo,
                        internal: tableDataRangeInternal,
                        date: date,
                        // applicant: applicant,
                        signatory: signatory,
                        date2: date2
                    }
                    : {},

            local:
                type === "Local Porting"
                    ? {
                        name3: name3,
                        brn3: brn3,
                        officer3: officer3,
                        contact: contact,
                        address: address,
                        postal: postal,
                        local: tableDataRangeLocal,
                        n2: tableDataRangeN2,
                        date3: date3,
                        portIn: portIn,
                        portBack: portBack,
                        // signature: signature,
                        date4: date4,
                        signatory2: signatory2
                    }
                    : {},

            mandatory: {
                date5: date5,
                name4: name4,
                uen: uen,
                //range: tableDataRange,
                //signature2: signature2,
                name5: name5,
                title: title,
                name6: name6
            }
        },

        email: sessionStorage.getItem("email")
    };

    const jsonString = JSON.stringify(json);

    // console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {

        let validationErrors = {};

        if (!type) {
            validationErrors.type = 'Please choose LOA Type';
        }

        if (type === 'Internal Porting') {

            if (!name1) {
                validationErrors.name1 = 'Please fill in Name of Company in Customer Details';
            }
            if (!brn1) {
                validationErrors.brn1 = 'Please fill in Company BRN in Customer Details';
            }
            if (!officer1) {
                validationErrors.officer1 = 'Please fill in Name of Authorized Officer in Customer Details';
            }
            if (!accNum1) {
                validationErrors.accNum1 = 'please fill in Singtel Billing Account Number in Customer Details';
            }
            if (!name2) {
                validationErrors.name2 = 'Please fill in Name of Company in Company Details';
            }
            if (!brn2) {
                validationErrors.brn2 = 'Please fill in Company BRN in Company Details';
            }
            if (!accNum2) {
                validationErrors.accNum2 = 'Please fill in Singtel Billing Account Number in Company Details';
            }
            if (!portFrom) {
                validationErrors.portFrom = 'Please fill in Singtel Local Telephony Service to be Ported FROM';
            }
            if (!portTo) {
                validationErrors.portTo = 'Please fill in Singtel Telephony Service to be Ported TO';
            }
            tableDataRangeInternal.forEach(row => {
                const startId = `startNumber-internal-${row.id}`;
                const endId = `endNumber-internal-${row.id}`;

                if (!row.sNumber) {
                    validationErrors[startId] = 'Start number cannot be empty.';
                } else if (!/^\d+$/.test(row.sNumber)) {
                    validationErrors[startId] = 'Start number must be numeric.';
                }

                if (!row.eNumber) {
                    validationErrors[endId] = 'End number cannot be empty.';
                } else if (!/^\d+$/.test(row.eNumber)) {
                    validationErrors[endId] = 'End number must be numeric.';
                }
            });
            if (!date) {
                validationErrors.date = 'Please fill in Porting Date';
            }
            // if (!applicant) {
            //     validationErrors.applicant = 'Please fill in Signature of Applicant/Authorised Officer';
            // }
            if (!signatory) {
                validationErrors.signatory = 'Please fill in Name and Designation of Signatory';
            }
            if (!date2) {
                validationErrors.date2 = 'Please fill in Date';
            }
        }

        if (type === 'Local Porting') {

            if (!name3) {
                validationErrors.name3 = 'Please fill in Name of Company / Firm';
            }
            if (!brn3) {
                validationErrors.brn3 = 'Please fill in BRN / UEN';
            }
            if (!officer3) {
                validationErrors.officer3 = 'Please fill in Authorized Officer Name';
            }
            if (!contact) {
                validationErrors.contact = 'please fill in Contact Number';
            }
            if (!address) {
                validationErrors.address = 'Please fill in Installation Address';
            }
            if (!postal) {
                validationErrors.postal = 'Please fill in Postal Code';
            }
            tableDataRangeLocal.forEach(row => {
                const startId = `startNumber-local-${row.id}`;
                const endId = `endNumber-local-${row.id}`;

                if (!row.sNumber) {
                    validationErrors[startId] = 'Start number cannot be empty.';
                } else if (!/^\d+$/.test(row.sNumber)) {
                    validationErrors[startId] = 'Start number must be numeric.';
                }

                if (!row.eNumber) {
                    validationErrors[endId] = 'End number cannot be empty.';
                } else if (!/^\d+$/.test(row.eNumber)) {
                    validationErrors[endId] = 'End number must be numeric.';
                }
            });
            tableDataRangeN2.forEach(row => {
                const startId = `startNumber-n2-${row.id}`;
                const endId = `endNumber-n2-${row.id}`;

                if (row.sNumber && !/^\d+$/.test(row.sNumber)) {
                    validationErrors[startId] = 'Start number must be numeric.';
                }

                if (row.eNumber && !/^\d+$/.test(row.eNumber)) {
                    validationErrors[endId] = 'End number must be numeric.';
                }
            });
            if (!date3) {
                validationErrors.date3 = 'Please fill in Service Activation Date';
            }
            // if (!signature) {
            //     validationErrors.signature = 'Please fill in Signature';
            // }
            if (!date4) {
                validationErrors.date4 = 'Please fill in Date';
            }
            if (!signatory2) {
                validationErrors.signatory2 = 'Please fill in Name and Designation of Signatory';
            }
        }

        if (!date5) {
            validationErrors.date5 = 'Please fill in Date under Letter of Authorization';
        }
        if (!name4) {
            validationErrors.name4 = 'Please fill in Company Name under Letter of Authorization';
        }
        if (!uen) {
            validationErrors.uen = 'Please fill in UEN under Letter of Authorization';
        }
        // tableDataRange.forEach(row => {
        //     const startId = `startNumber-range-${row.id}`;
        //     const endId = `endNumber-range-${row.id}`;

        //     // ---- Start Number ----
        //     if (!row.sNumber) {
        //         validationErrors[startId] = 'Start number cannot be empty.';
        //     } else if (!/^\d+$/.test(row.sNumber)) {
        //         validationErrors[startId] = 'Start number must be numeric.';
        //     } else if (!/^\d{9,11}$/.test(row.sNumber)) {
        //         validationErrors[startId] = 'Start number must be 9–11 digits.';
        //     }

        //     // ---- End Number ----
        //     if (!row.eNumber) {
        //         validationErrors[endId] = 'End number cannot be empty.';
        //     } else if (!/^\d+$/.test(row.eNumber)) {
        //         validationErrors[endId] = 'End number must be numeric.';
        //     } else if (!/^\d{9,11}$/.test(row.eNumber)) {
        //         validationErrors[endId] = 'End number must be 9–11 digits.';
        //     }
        // });
        // if (!signature2) {
        //     validationErrors.signature2 = 'Please fill in Signature under Letter of Authorization';
        // }
        if (!name5) {
            validationErrors.name5 = 'Please fill in Name under Letter of Authorization';
        }
        if (!title) {
            validationErrors.title = 'Please fill in Title under Letter of Authorization';
        }
        if (!name6) {
            validationErrors.name6 = 'Please fill in Company Name under Letter of Authorization';
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            //Show the first error message
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            document.getElementById(firstErrorKey).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(firstError);
            return;

        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys} `);
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            return;
        }
        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = name1 + '-LOA.zip';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            // toast.error("An error occurred while processing your request.");
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home'
        }
    }

    //----------------------------------------------RESET and SAVE--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div key={type}>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <div
                    style={{
                        marginTop: '-30px',
                        padding: '12px 14px',
                        borderLeft: '4px solid #d32f2f',
                        backgroundColor: '#fdecea',
                        color: '#8a1c1c',
                        fontSize: '14px',
                        borderRadius: '4px'
                    }}
                >
                    <p style={{ margin: 0 }}>
                        <strong>Disclaimer:</strong> All Letters of Authorization (LOA), the signature and company stamp
                        must be applied manually following the completion of the document fields.
                        Electronic signatures or pre-stamped templates are not permitted.
                    </p>

                    <a
                        href="/Read_Me_SG_Porting_with_the_right_docs.pdf"
                        download
                        style={{
                            display: 'inline-block',
                            marginTop: '6px',
                            color: '#b71c1c',
                            fontWeight: 500,
                            textDecoration: 'underline'
                        }}
                    >
                        📄 Download LOA Manual (PDF)
                    </a>
                </div>

                <br></br>

                <p><strong>Mandatory fields are marked by *</strong></p>

                <label>LOA Type*</label> <br />
                <div
                    onMouseEnter={() => handleMouseEnter('type')}
                    onMouseLeave={handleMouseLeave}
                >
                    <select
                        id="type"
                        value={type}
                        onChange={(e) => {
                            setType(e.target.value);
                            setValidationStates({});
                        }}
                        className={`inputbox ${validationStates.type === false ? 'error' : ''}`}
                        onBlur={() => validateInput('type', /^.*$/)}
                    >
                        <option value="">Select one</option>
                        <option value="Internal Porting">Internal Porting</option>
                        <option value="Local Porting">Local Porting</option>
                    </select>

                    {hoveredField === 'type' && (
                        <div className="hover-description">
                            Select the LOA type
                        </div>
                    )}
                </div>

                <br></br><br></br>

                {type === 'Internal Porting' && (
                    <Container>

                        <p>
                            Application for Internal Number Portability for Local Telephony Service.<br />
                            Note: This is an application form for the Customer to port/transfer its Local Telephone Number(s) assigned to it as part of its subscription to Singtel’s Local Telephony Service (as indicated below) to the Recipient Company’s Singtel ISDN or SIP Trunking (“(ISDN/SIP)”) service.
                        </p>

                        <br></br>

                        <h2 className='heading'>Customer Details</h2> <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('name1')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Name of Company*</label> <br />
                                <input
                                    onChange={(e) => setName1(e.target.value)}
                                    type="text"
                                    id="name1"
                                    placeholder=""
                                    className={`inputbox ${validationStates.name1 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('name1', /^[a-zA-Z\s]+$/)}

                                />
                                {hoveredField === 'name1' && (
                                    <div className="hover-description">
                                        Enter Customer Name in Capital Letters
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('brn1')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Company BRN*</label> <br />
                                <input
                                    onChange={(e) => { setBrn1(e.target.value) }}
                                    type="text"
                                    id="brn1"
                                    placeholder=""
                                    className={`inputbox ${validationStates.brn1 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('brn1', /^[a-zA-Z0-9\s\W]+$/)}

                                />
                                {hoveredField === 'brn1' && (
                                    <div className="hover-description">
                                        Enter BRN Number (example: 199505973R)
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('officer1')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Name of Authorized Officer*</label> <br />
                                <input
                                    onChange={(e) => setOfficer1(e.target.value)}
                                    type="text"
                                    id="officer1"
                                    placeholder=""
                                    className={`inputbox ${validationStates.officer1 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('officer1', /^[a-zA-Z\s]+$/)}

                                />
                                {hoveredField === 'officer1' && (
                                    <div className="hover-description">
                                        Enter Authorized Name
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('accNum1')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Singtel Billing Account Number*</label> <br />
                                <input
                                    onChange={(e) => setAccNum1(e.target.value)}
                                    type="text"
                                    id="accNum1"
                                    placeholder=""
                                    className={`inputbox ${validationStates.accNum1 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('accNum1', /^[0-9\s]+$/)}

                                />
                                {hoveredField === 'accNum1' && (
                                    <div className="hover-description">
                                        Enter account number (example: 81115533)
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br><br></br>

                        <h2 className='heading'>Company Details</h2> <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('name2')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Name of Company*</label> <br />
                                <input
                                    onChange={(e) => setName2(e.target.value)}
                                    type="text"
                                    id="name2"
                                    placeholder=""
                                    className={`inputbox ${validationStates.name2 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('name2', /^[a-zA-Z\s]+$/)}

                                />
                                {hoveredField === 'name2' && (
                                    <div className="hover-description">
                                        Enter Customer Name in Capital Letters
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('brn2')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Company BRN*</label> <br />
                                <input
                                    onChange={(e) => { setBrn2(e.target.value) }}
                                    type="text"
                                    id="brn2"
                                    placeholder=""
                                    className={`inputbox ${validationStates.brn2 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('brn2', /^[a-zA-Z0-9\s\W]+$/)}

                                />
                                {hoveredField === 'brn2' && (
                                    <div className="hover-description">
                                        Enter brn number (example: 199505973R)
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('officer2')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Name of Authorized Officer</label> <br />
                                <input
                                    type="text"
                                    id="officer2"
                                    className={`inputbox ${validationStates.officer2 === false ? 'error' : ''}`}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setOfficer2(value);

                                        if (value.trim() === '') {
                                            setValidationStates(prev => ({
                                                ...prev,
                                                officer2: true
                                            }));
                                        }
                                    }}
                                    onBlur={() => {
                                        if (officer2?.trim()) {
                                            validateInput('officer2', /^[a-zA-Z\s]+$/);
                                        }
                                    }}
                                />
                                {hoveredField === 'officer2' && (
                                    <div className="hover-description">
                                        Enter Authorized Name
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('accNum2')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Singtel Billing Account Number*</label> <br />
                                <input
                                    onChange={(e) => setAccNum2(e.target.value)}
                                    type="text"
                                    id="accNum2"
                                    placeholder=""
                                    className={`inputbox ${validationStates.accNum2 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('accNum2', /^[0-9\s]+$/)}

                                />
                                {hoveredField === 'accNum2' && (
                                    <div className="hover-description">
                                        Enter billing number
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br><br></br>

                        <h2 className='heading'>Telephony Details</h2> <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('portFrom')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Singtel Local Telephony Service to be Ported FROM*</label> <br />
                                <select
                                    id="portFrom"
                                    onChange={(e) => setPortFrom(e.target.value)}
                                    className={`inputbox ${validationStates.portFrom === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('portFrom', /^.*$/)}
                                >
                                    <option value="">Select one</option>
                                    <option value="BizDEL">BizDEL</option>
                                    <option value="PhoneNet">PhoneNet</option>
                                    <option value="BizVoice">BizVoice</option>
                                    <option value="ISDN">ISDN</option>
                                    <option value="SIP Trunking">SIP Trunking</option>
                                </select>
                                {hoveredField === 'portFrom' && (
                                    <div className="hover-description">
                                        Please choose one of these services
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('portTo')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Singtel Telephony Service to be Ported TO*</label> <br />
                                <select
                                    id="portTo"
                                    onChange={(e) => setPortTo(e.target.value)}
                                    className={`inputbox ${validationStates.portTo === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('portTo', /^.*$/)}
                                >
                                    <option value="">Select one</option>
                                    <option value="ISDN">ISDN</option>
                                    <option value="SIP Trunking">SIP Trunking</option>
                                </select>
                                {hoveredField === 'portTo' && (
                                    <div className="hover-description">
                                        Please choose one of these services
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br>

                        <label>List of Local Telephone Number(s)*</label>

                        <br></br><br></br>

                        <Row>
                            <Col>
                                <button
                                    type="button"
                                    className="inputbox"
                                    style={{ alignItems: 'center' }}
                                    onClick={() => fileRefInternal.current.click()}
                                >
                                    <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                    Upload File
                                </button>

                                <input
                                    id="fileUploadInput-internal"
                                    type="file"
                                    accept=".xlsx, .xls"
                                    ref={fileRefInternal}
                                    style={{ display: 'none' }}
                                    onChange={(e) => handleFileUpload(e, 'internal')}
                                />
                            </Col>

                            <Col>
                                <button
                                    type="button"
                                    className="inputbox"
                                    style={{ alignItems: 'center' }}
                                    onClick={() => handleDownload('portabilityImportTemplate.xlsx')}
                                >
                                    <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                    Download number range template
                                </button>
                            </Col>

                            <Col>
                                {uploadedFiles.internal && (
                                    <button
                                        type="button"
                                        onClick={() => removeUploadedFile('internal', fileRefInternal)}
                                        className="inputbox"
                                        style={{ alignItems: 'center' }}
                                    >
                                        <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                        Remove
                                    </button>
                                )}
                            </Col>
                        </Row>

                        <p>The template is the same used for the btd portability request.</p>

                        <Table striped bordered hover variant="light">
                            <thead>
                                <tr>
                                    <th>Number range start*</th>
                                    <th>Number range end*</th>
                                    <th>Number Type*</th>
                                </tr>
                            </thead>

                            <tbody>
                                {tableDataRangeInternal.map(row => (
                                    <tr key={row.id}>

                                        {/* START NUMBER */}
                                        <td
                                            onMouseEnter={() => handleMouseEnter(`startNumber-internal-${row.id}`)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <input
                                                type="text"
                                                id={`startNumber-internal-${row.id}`}
                                                value={row.sNumber}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    // allow typing anything, validate below
                                                    handleChangeTable('internal', row.id, 'sNumber', value);

                                                    let isValid = true;
                                                    if (value !== '' && !/^\d+$/.test(value)) {
                                                        isValid = false;
                                                    }

                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-internal-${row.id}`]: isValid,
                                                    }));
                                                }}
                                                className={`inputbox ${validationStates[`startNumber-internal-${row.id}`] === false ? 'error' : ''
                                                    }`}
                                                onBlur={() => {
                                                    if (!row.sNumber) {
                                                        toast.error('Start number cannot be empty.');
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`startNumber-internal-${row.id}`]: false,
                                                        }));
                                                    } else if (!/^\d+$/.test(row.sNumber)) {
                                                        toast.error('Only numeric values are allowed.');
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`startNumber-internal-${row.id}`]: false,
                                                        }));
                                                    }
                                                }}
                                            />

                                            {hoveredField === `startNumber-internal-${row.id}` && (
                                                <div className="hover-description">
                                                    Enter starting number (numeric only)
                                                </div>
                                            )}

                                            {validationStates[`startNumber-internal-${row.id}`] === false && (
                                                <div className="error-message">
                                                    {!row.sNumber
                                                        ? 'Start number cannot be empty.'
                                                        : 'Only numeric values are allowed.'}
                                                </div>
                                            )}
                                        </td>

                                        {/* END NUMBER */}
                                        <td
                                            onMouseEnter={() => handleMouseEnter(`endNumber-internal-${row.id}`)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <input
                                                type="text"
                                                id={`endNumber-internal-${row.id}`}
                                                value={row.eNumber}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    handleChangeTable('internal', row.id, 'eNumber', value);

                                                    let isValid = true;
                                                    if (value !== '' && !/^\d+$/.test(value)) {
                                                        isValid = false;
                                                    }

                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-internal-${row.id}`]: isValid,
                                                    }));
                                                }}
                                                className={`inputbox ${validationStates[`endNumber-internal-${row.id}`] === false ? 'error' : ''
                                                    }`}
                                                onBlur={() => {
                                                    if (!row.eNumber) {
                                                        toast.error('End number cannot be empty.');
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`endNumber-internal-${row.id}`]: false,
                                                        }));
                                                    } else if (!/^\d+$/.test(row.eNumber)) {
                                                        toast.error('Only numeric values are allowed.');
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`endNumber-internal-${row.id}`]: false,
                                                        }));
                                                    }
                                                }}
                                            />

                                            {hoveredField === `endNumber-internal-${row.id}` && (
                                                <div className="hover-description">
                                                    Enter ending number (numeric only)
                                                </div>
                                            )}

                                            {validationStates[`endNumber-internal-${row.id}`] === false && (
                                                <div className="error-message">
                                                    {!row.eNumber
                                                        ? 'End number cannot be empty.'
                                                        : 'Only numeric values are allowed.'}
                                                </div>
                                            )}
                                        </td>

                                        {/* NUMBER TYPE */}
                                        <td
                                            onMouseEnter={() => handleMouseEnter(`numType-internal-${row.id}`)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <select
                                                id={`numType-internal-${row.id}`}
                                                value={row.numType}
                                                onChange={(e) =>
                                                    handleChangeTable('internal', row.id, 'numType', e.target.value)
                                                }
                                                className={`inputbox ${validationStates[`numType-internal-${row.id}`] === false ? 'error' : ''
                                                    }`}
                                                onBlur={() => {
                                                    if (!row.numType) {
                                                        toast.error('Number Type is required.');
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`numType-internal-${row.id}`]: false,
                                                        }));
                                                    } else {
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`numType-internal-${row.id}`]: true,
                                                        }));
                                                    }
                                                }}
                                            >
                                                <option value=""></option>
                                                <option value="Geographical">Geographical</option>
                                                <option value="Nomadic">Nomadic</option>
                                            </select>

                                            {hoveredField === `numType-internal-${row.id}` && (
                                                <div className="hover-description">
                                                    Select the number type (Geographical or Nomadic)
                                                </div>
                                            )}

                                            {validationStates[`numType-internal-${row.id}`] === false && (
                                                <div className="error-message">
                                                    Number Type is required.
                                                </div>
                                            )}
                                        </td>

                                        {/* ACTION */}
                                        <td>
                                            {tableDataRangeInternal.length > 1 && (
                                                <button onClick={() => removeRow('internal', row.id)}>
                                                    Remove
                                                </button>
                                            )}
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <button onClick={() => addRow('internal')}>Add Row</button>

                        <br></br><br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('date')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Porting Date*</label> <br />
                                <input
                                    onChange={(e) => setDate(e.target.value)}
                                    type="date"
                                    id="date"
                                    value={date} // Automatically set the current date
                                    className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('date', /^.*$/)}
                                    min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                                />

                                {hoveredField === 'date' && (
                                    <div className="hover-description">
                                        Select porting date (future dates only)
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            {/* <Col
                                onMouseEnter={() => handleMouseEnter('applicant')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Signature of Applicant/Authorised Officer*</label> <br />
                                <input
                                    onChange={(e) => setApplicant(e.target.value)}
                                    type="text"
                                    id="applicant"
                                    placeholder=""
                                    className={`inputbox ${validationStates.applicant === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('applicant', /^[a-zA-Z\s]+$/)}

                                />
                                {hoveredField === 'applicant' && (
                                    <div className="hover-description">
                                        Signature
                                    </div>
                                )}
                            </Col> */}

                            <Col
                                onMouseEnter={() => handleMouseEnter('signatory')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Name and Designation of Signatory*</label> <br />
                                <input
                                    onChange={(e) => { setSignatory(e.target.value) }}
                                    type="text"
                                    id="signatory"
                                    placeholder=""
                                    className={`inputbox ${validationStates.signatory === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('signatory', /^[a-zA-Z0-9\s\W]+$/)}

                                />
                                {hoveredField === 'signatory' && (
                                    <div className="hover-description">
                                        Enter Authorized Name
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('date2')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Date*</label> <br />
                                <input
                                    onChange={(e) => setDate2(e.target.value)}
                                    type="date"
                                    id="date2"
                                    value={date2} // Automatically set the current date
                                    className={`inputbox ${validationStates.date2 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('date2', /^.*$/)}
                                    min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                                />

                                {hoveredField === 'date2' && (
                                    <div className="hover-description">
                                        Select a future date (today and past dates are disabled)
                                    </div>
                                )}
                            </Col>

                        </Row>

                    </Container>
                )}

                {type === 'Local Porting' && (
                    <Container>

                        <p>Application for Number Portability for Local Telephony Service</p>

                        <br></br>

                        <h2 className='heading'>Business / Corporate Particulars</h2> <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('name3')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Name of Company / Firm*</label> <br />
                                <input
                                    onChange={(e) => setName3(e.target.value)}
                                    type="text"
                                    id="name3"
                                    placeholder=""
                                    className={`inputbox ${validationStates.name3 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('name3', /^[a-zA-Z0-9\s\W]+$/)}

                                />
                                {hoveredField === 'name3' && (
                                    <div className="hover-description">
                                        Enter Company name
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('brn3')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>BRN / UEN*</label> <br />
                                <input
                                    onChange={(e) => { setBrn3(e.target.value) }}
                                    type="text"
                                    id="brn3"
                                    placeholder=""
                                    className={`inputbox ${validationStates.brn3 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('brn3', /^[a-zA-Z0-9\s\W]+$/)}

                                />
                                {hoveredField === 'brn3' && (
                                    <div className="hover-description">
                                        Enter brn number
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('officer3')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Authorized Officer Name*</label> <br />
                                <input
                                    onChange={(e) => setOfficer3(e.target.value)}
                                    type="text"
                                    id="officer3"
                                    placeholder=""
                                    className={`inputbox ${validationStates.officer3 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('officer3', /^[a-zA-Z0-9\s\W]+$/)}
                                />
                                {hoveredField === 'officer3' && (
                                    <div className="hover-description">
                                        Enter authorized name
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('contact')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Contact Number*</label> <br />
                                <input
                                    onChange={(e) => setContact(e.target.value)}
                                    type="text"
                                    id="contact"
                                    placeholder=""
                                    className={`inputbox ${validationStates.contact === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('contact', /^[0-9\s]+$/)}

                                />
                                {hoveredField === 'contact' && (
                                    <div className="hover-description">
                                        Enter Number
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('address')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Installation Address*</label> <br />
                                <input
                                    onChange={(e) => { setAddress(e.target.value) }}
                                    type="text"
                                    id="address"
                                    placeholder=""
                                    className={`inputbox ${validationStates.address === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('address', /^[a-zA-Z0-9\s\W]+$/)}

                                />
                                {hoveredField === 'address' && (
                                    <div className="hover-description">
                                        Enter Address
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('postal')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Postal Code*</label> <br />
                                <input
                                    onChange={(e) => setPostal(e.target.value)}
                                    type="text"
                                    id="postal"
                                    placeholder=""
                                    className={`inputbox ${validationStates.postal === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('postal', /^[0-9\s]+$/)}

                                />
                                {hoveredField === 'postal' && (
                                    <div className="hover-description">
                                        Enter Code
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br><br></br>

                        <h2 className='heading'>Telephony Details</h2> <br></br>

                        <label>List of Local Telephone Number(s) to be ported*</label>
                        <br /><br />

                        <Row>
                            <Col>
                                <button
                                    type="button"
                                    className="inputbox"
                                    onClick={() => fileRefLocal.current.click()}
                                >
                                    <FontAwesomeIcon icon={faUpload} /> Upload File
                                </button>

                                <input
                                    type="file"
                                    accept=".xlsx,.xls"
                                    ref={fileRefLocal}
                                    style={{ display: 'none' }}
                                    onChange={(e) => handleFileUpload(e, 'local')}
                                />
                            </Col>

                            <Col>
                                <button
                                    type="button"
                                    className="inputbox"
                                    onClick={handleDownload}
                                >
                                    <FontAwesomeIcon icon={faDownload} /> Download template
                                </button>
                            </Col>

                            <Col>
                                {uploadedFiles.local && (
                                    <button
                                        type="button"
                                        className="inputbox"
                                        onClick={() => removeUploadedFile('local', fileRefLocal)}
                                    >
                                        <FontAwesomeIcon icon={faTrash} /> Remove
                                    </button>
                                )}
                            </Col>
                        </Row>

                        <p>The template is the same used for the btd portability request.</p>

                        <Table striped bordered hover variant="light">
                            <thead>
                                <tr>
                                    <th>Number range start*</th>
                                    <th>Number range end*</th>
                                </tr>
                            </thead>

                            <tbody>
                                {tableDataRangeLocal.map(row => (
                                    <tr key={row.id}>

                                        {/* START */}
                                        <td
                                            onMouseEnter={() => handleMouseEnter(`startNumber-local-${row.id}`)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <input
                                                type="text"
                                                value={row.sNumber}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    handleChangeTable('local', row.id, 'sNumber', value);

                                                    let isValid = true;
                                                    if (value !== '' && !/^\d+$/.test(value)) isValid = false;

                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-local-${row.id}`]: isValid,
                                                    }));
                                                }}
                                                className={`inputbox ${validationStates[`startNumber-local-${row.id}`] === false ? 'error' : ''
                                                    }`}
                                                onBlur={() => {
                                                    if (!row.sNumber) {
                                                        toast.error('Start number cannot be empty.');
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`startNumber-local-${row.id}`]: false,
                                                        }));
                                                    } else if (!/^\d+$/.test(row.sNumber)) {
                                                        toast.error('Only numeric values are allowed.');
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`startNumber-local-${row.id}`]: false,
                                                        }));
                                                    }
                                                }}
                                            />

                                            {hoveredField === `startNumber-local-${row.id}` && (
                                                <div className="hover-description">
                                                    Enter starting number (numeric only)
                                                </div>
                                            )}

                                            {validationStates[`startNumber-local-${row.id}`] === false && (
                                                <div className="error-message">
                                                    {!row.sNumber
                                                        ? 'Start number cannot be empty.'
                                                        : 'Only numeric values are allowed.'}
                                                </div>
                                            )}
                                        </td>

                                        {/* END */}
                                        <td
                                            onMouseEnter={() => handleMouseEnter(`endNumber-local-${row.id}`)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <input
                                                type="text"
                                                value={row.eNumber}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    handleChangeTable('local', row.id, 'eNumber', value);

                                                    let isValid = true;
                                                    if (value !== '' && !/^\d+$/.test(value)) isValid = false;

                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-local-${row.id}`]: isValid,
                                                    }));
                                                }}
                                                className={`inputbox ${validationStates[`endNumber-local-${row.id}`] === false ? 'error' : ''
                                                    }`}
                                                onBlur={() => {
                                                    if (!row.eNumber) {
                                                        toast.error('End number cannot be empty.');
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`endNumber-local-${row.id}`]: false,
                                                        }));
                                                    } else if (!/^\d+$/.test(row.eNumber)) {
                                                        toast.error('Only numeric values are allowed.');
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`endNumber-local-${row.id}`]: false,
                                                        }));
                                                    }
                                                }}
                                            />

                                            {hoveredField === `endNumber-local-${row.id}` && (
                                                <div className="hover-description">
                                                    Enter ending number (numeric only)
                                                </div>
                                            )}

                                            {validationStates[`endNumber-local-${row.id}`] === false && (
                                                <div className="error-message">
                                                    {!row.eNumber
                                                        ? 'End number cannot be empty.'
                                                        : 'Only numeric values are allowed.'}
                                                </div>
                                            )}
                                        </td>

                                        <td>
                                            {tableDataRangeLocal.length > 1 && (
                                                <button onClick={() => removeRow('local', row.id)}>
                                                    Remove
                                                </button>
                                            )}
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <button onClick={() => addRow('local')}>Add Row</button>

                        <br></br><br></br><br></br>

                        <label>N2 Number Range</label>
                        <br /><br />

                        <Row>
                            <Col>
                                <button
                                    type="button"
                                    className="inputbox"
                                    onClick={() => fileRefN2.current.click()}
                                >
                                    <FontAwesomeIcon icon={faUpload} /> Upload File
                                </button>

                                <input
                                    type="file"
                                    accept=".xlsx,.xls"
                                    ref={fileRefN2}
                                    style={{ display: 'none' }}
                                    onChange={(e) => handleFileUpload(e, 'n2')}
                                />
                            </Col>

                            <Col>
                                <button
                                    type="button"
                                    className="inputbox"
                                    onClick={handleDownload}
                                >
                                    <FontAwesomeIcon icon={faDownload} /> Download template
                                </button>
                            </Col>

                            <Col>
                                {uploadedFiles.n2 && (
                                    <button
                                        type="button"
                                        className="inputbox"
                                        onClick={() => removeUploadedFile('n2', fileRefN2)}
                                    >
                                        <FontAwesomeIcon icon={faTrash} /> Remove
                                    </button>
                                )}
                            </Col>
                        </Row>

                        <p>The template is the same used for the btd portability request.</p>

                        <Table striped bordered hover variant="light">
                            <thead>
                                <tr>
                                    <th>Number range start</th>
                                    <th>Number range end</th>
                                </tr>
                            </thead>

                            <tbody>
                                {tableDataRangeN2.map(row => (
                                    <tr key={row.id}>

                                        {/* START */}
                                        <td
                                            onMouseEnter={() => handleMouseEnter(`startNumber-n2-${row.id}`)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <input
                                                type="text"
                                                value={row.sNumber}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    handleChangeTable('n2', row.id, 'sNumber', value);

                                                    let isValid = true;
                                                    if (value !== '' && !/^\d+$/.test(value)) isValid = false;

                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-n2-${row.id}`]: isValid,
                                                    }));
                                                }}
                                                className={`inputbox ${validationStates[`startNumber-n2-${row.id}`] === false ? 'error' : ''
                                                    }`}
                                                onBlur={() => {
                                                    if (row.sNumber && !/^\d+$/.test(row.sNumber)) {
                                                        toast.error('Only numeric values are allowed.');
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`startNumber-n2-${row.id}`]: false,
                                                        }));
                                                    }
                                                }}
                                            />

                                            {hoveredField === `startNumber-n2-${row.id}` && (
                                                <div className="hover-description">
                                                    Enter starting number (numeric only)
                                                </div>
                                            )}

                                            {validationStates[`startNumber-n2-${row.id}`] === false && (
                                                <div className="error-message">
                                                    Only numeric values are allowed.
                                                </div>
                                            )}
                                        </td>

                                        {/* END */}
                                        <td
                                            onMouseEnter={() => handleMouseEnter(`endNumber-n2-${row.id}`)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <input
                                                type="text"
                                                value={row.eNumber}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    handleChangeTable('n2', row.id, 'eNumber', value);

                                                    let isValid = true;
                                                    if (value !== '' && !/^\d+$/.test(value)) isValid = false;

                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-n2-${row.id}`]: isValid,
                                                    }));
                                                }}
                                                className={`inputbox ${validationStates[`endNumber-n2-${row.id}`] === false ? 'error' : ''
                                                    }`}
                                                onBlur={() => {
                                                    if (row.eNumber && !/^\d+$/.test(row.eNumber)) {
                                                        toast.error('Only numeric values are allowed.');
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`endNumber-n2-${row.id}`]: false,
                                                        }));
                                                    }
                                                }}
                                            />

                                            {hoveredField === `endNumber-n2-${row.id}` && (
                                                <div className="hover-description">
                                                    Enter ending number (numeric only)
                                                </div>
                                            )}

                                            {validationStates[`endNumber-n2-${row.id}`] === false && (
                                                <div className="error-message">
                                                    Only numeric values are allowed.
                                                </div>
                                            )}
                                        </td>

                                        <td>
                                            {tableDataRangeN2.length > 1 && (
                                                <button onClick={() => removeRow('n2', row.id)}>
                                                    Remove
                                                </button>
                                            )}
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <button onClick={() => addRow('n2')}>Add Row</button>

                        <br></br><br></br><br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('date3')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Service Activation Date (excluding Sat, Sun & PH)*</label> <br />
                                <input
                                    onChange={(e) => setDate3(e.target.value)}
                                    type="date"
                                    id="date3"
                                    value={date3} // Automatically set the current date
                                    className={`inputbox ${validationStates.date3 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('date3', /^.*$/)}
                                    min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                                />

                                {hoveredField === 'date3' && (
                                    <div className="hover-description">
                                        Select service activation date (excluding weekends and public holidays)
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            <Col>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={portIn}
                                        onChange={(e) => setPortIn(e.target.checked)}
                                        style={{ marginRight: '6px' }}
                                    />
                                    Port In Telephone Number
                                </label>
                            </Col>

                        </Row>

                        <br></br>

                        <Row>
                            <Col>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={portBack}
                                        onChange={(e) => setPortBack(e.target.checked)}
                                        style={{ marginRight: '6px' }}
                                    />
                                    Port Back Telephone Number
                                </label>
                            </Col>
                        </Row>

                        <br></br>

                        <Row>

                            {/* <Col
                                onMouseEnter={() => handleMouseEnter('signature')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Signature*</label> <br />
                                <input
                                    onChange={(e) => setSignature(e.target.value)}
                                    type="text"
                                    id="signature"
                                    placeholder=""
                                    className={`inputbox ${validationStates.signature === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('signature', /^[a-zA-Z0-9\s\W]+$/)}

                                />
                                {hoveredField === 'signature' && (
                                    <div className="hover-description">
                                        Enter Signature
                                    </div>
                                )}
                            </Col> */}

                            <Col
                                onMouseEnter={() => handleMouseEnter('date4')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Date*</label> <br />
                                <input
                                    onChange={(e) => setDate4(e.target.value)}
                                    type="date"
                                    id="date4"
                                    value={date4} // Automatically set the current date
                                    className={`inputbox ${validationStates.date4 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('date4', /^.*$/)}
                                    min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                                />

                                {hoveredField === 'date4' && (
                                    <div className="hover-description">
                                        Select a future date (today and past dates are disabled)
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('signatory2')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Name and Designation of Signatory*</label> <br />
                                <input
                                    onChange={(e) => { setSignatory2(e.target.value) }}
                                    type="text"
                                    id="signatory2"
                                    placeholder=""
                                    className={`inputbox ${validationStates.signatory2 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('signatory2', /^[a-zA-Z0-9\s\W]+$/)}

                                />
                                {hoveredField === 'signatory2' && (
                                    <div className="hover-description">
                                        Enter Signatory
                                    </div>
                                )}
                            </Col>

                        </Row>

                    </Container>
                )}

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Letter of Authorisation</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('date5')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Date*</label> <br />
                            <input
                                onChange={(e) => setDate5(e.target.value)}
                                type="date"
                                id="date5"
                                value={date5} // Automatically set the current date
                                className={`inputbox ${validationStates.date5 === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date5', /^.*$/)}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                            />

                            {hoveredField === 'date5' && (
                                <div className="hover-description">
                                    Select a future date (today and past dates are disabled)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('name4')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Company Name*</label> <br />
                            <input
                                onChange={(e) => setName4(e.target.value)}
                                type="text"
                                id="name4"
                                placeholder=""
                                className={`inputbox ${validationStates.name4 === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name4', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'name4' && (
                                <div className="hover-description">
                                    Enter Company Name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('uen')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>UEN*</label> <br />
                            <input
                                onChange={(e) => { setUen(e.target.value) }}
                                type="text"
                                id="uen"
                                placeholder=""
                                className={`inputbox ${validationStates.uen === false ? 'error' : ''}`}
                                onBlur={() => validateInput('uen', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'uen' && (
                                <div className="hover-description">
                                    Enter UEN
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br><br></br>

                    {/* <p>The undersigned authorises OBS to engage with Singtel to activate these range at the earliest possible date, in order to use telephony services at their premises with the following Business Registration Address</p>

                    <label>Number Range*</label> */}

                    {/* <br></br><br></br>

                    <Row>

                        <Col>
                            <button
                                type="button"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileRefRange.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>

                            <input
                                id="fileUploadInput-range"
                                type="file"
                                accept=".xlsx, .xls"
                                ref={fileRefRange}
                                style={{ display: 'none' }}
                                onChange={(e) => handleFileUpload(e, 'range')}
                            />
                        </Col>

                        <Col>
                            <button
                                type="button"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => handleDownload('portabilityImportTemplate.xlsx')}
                            >
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            {uploadedFiles.range && (
                                <button
                                    type="button"
                                    onClick={() => removeUploadedFile('range', fileRefRange)}
                                    className="inputbox"
                                    style={{ alignItems: 'center' }}
                                >
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>

                    </Row>

                    <p>The template is the same used for the btd portability request.</p> */}

                    {/* <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Number range start*</th>
                                <th>Number range end*</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataRange.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-range-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-range-${row.id}`}
                                            value={row.sNumber}
                                            maxLength={11}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (!/^\d*$/.test(value)) return;

                                                handleChangeTable('range', row.id, 'sNumber', value);

                                                let isValid = true;
                                                if (value !== '') {
                                                    isValid = /^\d{9,11}$/.test(value);
                                                }

                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`startNumber-range-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-range-${row.id}`] === false ? 'error' : ''
                                                }`}
                                            onBlur={() => {
                                                if (!row.sNumber) {
                                                    toast.error('Start number cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-range-${row.id}`]: false,
                                                    }));
                                                } else if (!/^\d{9,11}$/.test(row.sNumber)) {
                                                    toast.error('Start number must be 9–11 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-range-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />

                                        {hoveredField === `startNumber-range-${row.id}` && (
                                            <div className="hover-description">
                                                Enter start number (9–11 digits only)
                                            </div>
                                        )}

                                        {validationStates[`startNumber-range-${row.id}`] === false && (
                                            <div className="error-message">
                                                {!row.sNumber
                                                    ? 'Start number cannot be empty.'
                                                    : 'Start number must be 9–11 digits.'}
                                            </div>
                                        )}
                                    </td>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-range-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-range-${row.id}`}
                                            value={row.eNumber}
                                            maxLength={11}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (!/^\d*$/.test(value)) return;

                                                handleChangeTable('range', row.id, 'eNumber', value);

                                                let isValid = true;
                                                if (value !== '') {
                                                    isValid = /^\d{9,11}$/.test(value);
                                                }

                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`endNumber-range-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-range-${row.id}`] === false ? 'error' : ''
                                                }`}
                                            onBlur={() => {
                                                if (!row.eNumber) {
                                                    toast.error('End number cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-range-${row.id}`]: false,
                                                    }));
                                                } else if (!/^\d{9,11}$/.test(row.eNumber)) {
                                                    toast.error('End number must be 9–11 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-range-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />

                                        {hoveredField === `endNumber-range-${row.id}` && (
                                            <div className="hover-description">
                                                Enter end number (9–11 digits only)
                                            </div>
                                        )}

                                        {validationStates[`endNumber-range-${row.id}`] === false && (
                                            <div className="error-message">
                                                {!row.eNumber
                                                    ? 'End number cannot be empty.'
                                                    : 'End number must be 9–11 digits.'}
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow('range', row.id)}>Remove</button>
                                        )}
                                    </td>

                                </tr>
                            ))}

                        </tbody>
                    </Table> 

                    <button onClick={() => addRow('range')}>Add Row</button>*/}

                    <Row>

                        {/* <Col
                            onMouseEnter={() => handleMouseEnter('signature2')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Signature*</label> <br />
                            <input
                                onChange={(e) => setSignature2(e.target.value)}
                                type="text"
                                id="signature2"
                                placeholder=""
                                className={`inputbox ${validationStates.signature2 === false ? 'error' : ''}`}
                                onBlur={() => validateInput('signature2', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'signature2' && (
                                <div className="hover-description">
                                    Enter Signature
                                </div>
                            )}
                        </Col> */}

                        <Col
                            onMouseEnter={() => handleMouseEnter('name5')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Name*</label> <br />
                            <input
                                onChange={(e) => setName5(e.target.value)}
                                type="text"
                                id="name5"
                                placeholder=""
                                className={`inputbox ${validationStates.name5 === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name5', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'name5' && (
                                <div className="hover-description">
                                    Enter Name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('title')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Title*</label> <br />
                            <input
                                onChange={(e) => setTitle(e.target.value)}
                                type="text"
                                id="title"
                                placeholder=""
                                className={`inputbox ${validationStates.title === false ? 'error' : ''}`}
                                onBlur={() => validateInput('title', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'title' && (
                                <div className="hover-description">
                                    Enter Title
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('name6')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Company Name*</label> <br />
                            <input
                                onChange={(e) => setName6(e.target.value)}
                                type="text"
                                id="name6"
                                placeholder=""
                                className={`inputbox ${validationStates.name6 === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name6', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'name6' && (
                                <div className="hover-description">
                                    Enter Company Name
                                </div>
                            )}
                        </Col>

                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Singapore;